import { useQuery } from "react-query";
import { IObjectDefaultsModel } from "../../services/defaults-data-service/Models";
import ObjectDefaultsService from "../../services/defaults-data-service/DefaultsDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters"
import { keys } from "./Keys";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { RestError } from "../../services/rest-service/RestService";

export type UseObjectDefaultsQueryParams = {
    groupID: number,
    eLynxObject: IeLynxObject
} & BaseUseQueryParameters<IObjectDefaultsModel>;

export function useObjectDefaults(params: UseObjectDefaultsQueryParams) {
    return useQuery<IObjectDefaultsModel, RestError>(
        keys.defaults(params.groupID, params.eLynxObject),
        ({signal}) => {
            return ObjectDefaultsService.getDefaults(params.groupID, params.eLynxObject, signal);
        },
        {
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds * 1000 : false
        }
    );
}